import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=72cacfdb"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"
import style0 from "./InputCheckbox.vue?vue&type=style&index=0&id=72cacfdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports